module.exports = __webpack_public_path__ + "06ba2485a8083306e862b2b0e9f2cd20.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-19-harrison/tiger.jpg
// module id = 869
// module chunks = 0